import { endPoints, requestType } from "../theme/Variables";
import Api from "./index";

export const getAllReturnOrders = () => {
  return Api(endPoints.getAllReturnOrders, null, requestType.GET);
};

export const fetchReturnOrderDetails = (id) => {
  return Api(`${endPoints.returnDetails}/${id}`, null, requestType.GET);
};
export const updateReturnOrderStatus = (id, params) => {
  return Api(
    `${endPoints.updateReturnOrderStatus}/${id}`,
    params,
    requestType.POST
  );
};
